var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferringProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 59,
    viewBox: "0 0 44 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5916 35.7222L22 46.6111M22 46.6111L28.4084 35.7222M22 46.6111V57.5M31.6126 48.1667H34.8168M7.91189 57.5H36.0881C40.2986 57.5 43.365 53.6247 42.2801 49.6745L39.2895 38.7857C38.5415 36.0619 36.0009 34.1667 33.0975 34.1667H10.9025C7.99914 34.1667 5.45854 36.0619 4.71046 38.7857L1.71988 49.6745C0.634989 53.6247 3.70138 57.5 7.91189 57.5ZM34.8168 13.9444C34.8168 20.8173 29.0785 26.3889 22 26.3889C14.9215 26.3889 9.18323 20.8173 9.18323 13.9444C9.18323 7.07157 14.9215 1.5 22 1.5C29.0785 1.5 34.8168 7.07157 34.8168 13.9444Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferringProvider);
export default __webpack_public_path__ + "static/media/referringProvider.e57a52478df813fadfdc0b7349f0dd80.svg";
export { ForwardRef as ReactComponent };